<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{projectTitle}}</h2>
                <h2 class="page-title" style="margin-top: 10px;">设置资格审查内容</h2>
            </div>
        </div>

        <!-- 搜索区域 -->
        <div class="search-section">
            <el-form :inline="true" :model="searchForm">
                <el-form-item label="标段名称">
                    <el-input v-model="searchForm.bidSectionName" placeholder="请输入标段名称" clearable style="width: 300px;" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
              <div style="display: flex; align-items: center;">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>

            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center" />
                <el-table-column prop="bidSectionCode" label="标段编码" show-overflow-tooltip />
                <el-table-column prop="bidSectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="status" label="状态" align="center" width="100">
                    <template slot-scope="scope">
                        <!-- 资格审查完成后状态显示为提交 -->
                        <el-tag :type="scope.row.status === 0 ? 'info' : 'success'"  @click='tagClick'>
                            {{ scope.row.status === 0 ? '暂存' : '提交' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="详细信息" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleSetQualification(scope.row)"
                            class="action-btn">
                           
                             {{ scope.row.status === 0 ? ' 设置资格审查内容' : ' 查看资格审查内容' }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>
        <!-- 设置资格审查内容弹窗 -->
        <el-dialog title="设置资格审查内容" :visible.sync="qualificationDialogVisible" width="60%"
            :before-close="handleCloseDialog" :append-to-body="true" custom-class="qualification-dialog">
            <div class="qualification-content">
                <!-- 资格审查内容表格 -->
                <div class="qualification-table">
                    <div class="table-header">
                        <div class="header-cell">审查项名称</div>
                        <div class="header-cell">审查条件</div>
                        <div class="header-cell">操作</div>
                    </div>

                    <div class="table-body">
                        <div v-for="(item, index) in qualificationList" :key="index" class="table-row">
                            <div class="table-cell">
                                <el-input v-model="item.reviewItemName" placeholder="审查项名称" size="small" />
                            </div>
                            <div class="table-cell">
                                <el-input v-model="item.reviewCondition" placeholder="审查条件" size="small"  />
                            </div>
                            <div class="table-cell action-cell">
                                <el-button type="text" icon="el-icon-delete" @click="handleDeleteItem(index)"
                                    class="delete-btn"  />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 添加按钮 -->
                <div class="add-section">
                    <el-button type="primary" @click="handleAddItem" class="add-btn" v-if="status==0">
                        添加资格审查内容
                    </el-button>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSave" >{{status==0?'保存':'关闭'}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { loadProjectDetail} from '@/utils/bid/projectInfo'
import {qualificationReviewList,qualificationReviewAdd,qualificationReviewDetail }from '@/api/modules/qualificationReview'
export default {
    name: 'QualificationReview',
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            projectTitle: '',
            loading: false,
            qualificationDialogVisible: false,
            saving: false,
            status:0,
            searchForm: {
                bidSectionName: ''
            },
            tableData: [],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            qualificationList: [],
            currentBidSectionCode: '' // 当前选中的标段编码
        }
    },
    computed: {
    },
    
    mounted() {
        this.getProjectInfo()
        this.loadData()
    },
    methods: {

        tagClick(){
 this.$message.success('资格审查完成后状态显示为提交');
        },
        //  获取标题
        async getProjectInfo() {
            this.projectTitle = await loadProjectDetail(this.projectCode);
        },
        
        // 搜索
        handleSearch() {
            this.pagination.currentPage = 1
            this.loadData()
        },
        
        // 重置
        handleReset() {
            this.searchForm.bidSectionName = ''
            this.pagination.currentPage = 1
            this.loadData()
        },
        
        //列表
        loadData(){
            this.loading = true
            qualificationReviewList({
                projectCode: this.projectCode,
                bidSectionName: this.searchForm.bidSectionName,
                pageNum: this.pagination.currentPage,
                pageSize: this.pagination.pageSize,
                stage: 0
            }).then(res => {
                if (res.code === 200) {
                    const data = res.data
                    this.tableData = data.records.map((item, index) => ({
                        no: (this.pagination.currentPage - 1) * this.pagination.pageSize + index + 1,
                        bidSectionCode: item.bidSectionCode,
                        bidSectionName: item.bidSectionName,
                        status: item.status
                    }))
                    this.pagination.total = data.total
                }
            }).catch(err => {
                this.$message.error('获取标段列表失败');
                console.error(err);
            }).finally(() => {
                this.loading = false;
            });
        },

        handleBack() {
            this.$router.go(-1)
        },
        handleSetQualification(row) {
            this.status = row.status
            this.currentBidSectionCode = row.bidSectionCode
            this.qualificationDialogVisible = true
            this.qualificationReviewDetail(row.bidSectionCode)
        },
           // 获取资格审查内容
        qualificationReviewDetail(bidSectionCode){
           qualificationReviewDetail({
                bidSectionCode: bidSectionCode,
            }).then(res => {
                if (res.code === 200) {
                    this.qualificationList = res.data
                }
            }).catch(err => {
                this.$message.error('获取资格审查内容失败');
                console.error(err);
            }).finally(() => {
                this.loading = false;
            });
        },

        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },

        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },

        // 添加资格审查项
        handleAddItem() {
            this.qualificationList.push({
                reviewItemName: '',
                reviewCondition: ''
            })
        },
        // 删除项
        handleDeleteItem(index) {
            this.$confirm('确定要删除这个资格审查项吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.qualificationList.splice(index, 1)
                this.$message.success('删除成功')
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },

        // 关闭弹窗
        handleCloseDialog() {
            this.qualificationDialogVisible = false
        },

        // 保存
        handleSave() {
            // 验证数据
            for (let i = 0; i < this.qualificationList.length; i++) {
                const item = this.qualificationList[i]
                if (!item.reviewItemName || !item.reviewItemName.trim()) {
                    this.$message.error(`第${i + 1}行审查项名称不能为空`)
                    return
                }
                if (!item.reviewCondition || !item.reviewCondition.trim()) {
                    this.$message.error(`第${i + 1}行审查条件不能为空`)
                    return
                }
            }

            this.saving = true
            
            // 调用接口保存
            const params = {
                bidSectionCode: this.currentBidSectionCode,
                contents: this.qualificationList.map(item => ({
                    reviewItemName: item.reviewItemName,
                    reviewCondition: item.reviewCondition
                }))
            }
            qualificationReviewAdd(params).then(res => {
                if (res.code === 200) {
                    this.$message.success('保存成功')
                    this.qualificationDialogVisible = false
                    // 刷新列表
                    this.loadData()
                } else {
                    this.$message.error(res.message || '保存失败')
                }
            }).catch(err => {
                this.$message.error('保存失败')
                console.error(err)
            }).finally(() => {
                this.saving = false
            })
        }
    }
}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

// ============================================
// 应用极简灰度主题
// ============================================
.agent-page {
    .apply-minimal-gray-theme();
}

// ============================================
// 页面特定样式
// ============================================

// 页面头部（带返回按钮）
.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 20px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    ::v-deep .el-button {
        transition: all @transition-base ease;

        &:hover {
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    }
}

// 确认按钮
.confirm-btn {
    color: @success-color;

    &:hover {
        color: lighten(@success-color, 10%);
    }
}

// 删除按钮
.delete-btn {
    color: @error-color;

    &:hover {
        color: lighten(@error-color, 10%);
    }
}

// ============================================
// 弹窗样式
// ============================================
::v-deep .qualification-dialog {
    .minimal-dialog-styles();
}

// 弹窗内部内容样式
.qualification-content {
    .qualification-table {
        border: 1px solid @gray-200;
        border-radius: 4px;
        overflow: hidden;

        .table-header {
            display: flex;
            background: @gray-50;

            .header-cell {
                flex: 1;
                padding: 12px 15px;
                font-weight: 600;
                color: @gray-700;
                text-align: center;
                border-right: 1px solid @gray-200;

                &:last-child {
                    border-right: none;
                }
            }
        }

        .table-body {
            .table-row {
                display: flex;
                border-bottom: 1px solid @gray-200;
                background-color: #fff;
                transition: background-color @transition-fast ease;

                &:hover {
                    background-color: @gray-50;
                }

                &:last-child {
                    border-bottom: none;
                }

                .table-cell {
                    flex: 1;
                    padding: 10px 15px;
                    border-right: 1px solid @gray-200;
                    display: flex;
                    align-items: center;
                    color: @gray-600;

                    &:last-child {
                        border-right: none;
                    }

                    &.action-cell {
                        justify-content: center;
                        gap: 10px;
                    }
                }
            }
        }
    }

    .add-section {
        margin-top: 20px;
        text-align: center;

        .add-btn {
            transition: all @transition-base ease;

            &:hover {
                transform: translateY(-1px);
            }
        }
    }
}

.dialog-footer {
    text-align: center;
    padding: 16px 0 10px;
    border-top: 1px solid @gray-200;
    margin-top: 16px;

    .el-button {
        margin-left: 12px;
        transition: all @transition-base ease;

        &:hover {
            transform: translateY(-1px);
        }
    }
}
</style>
